import { nextTick as g } from "vue";
function E(e, o = 0, n = "") {
  let t = o + (n.length === 0 ? 1 : n.length);
  return e.slice(0, o) + n + e.slice(t);
}
var h = E;
const y = {
  "#": { pattern: "[0-9]" },
  $: { pattern: "[A-Za-z]" },
  "*": { pattern: "[A-Za-z0-9]" },
  A: { pattern: "[A-Z]", transform: (e) => e.toLocaleUpperCase() },
  a: { pattern: "[a-z]", transform: (e) => e.toLocaleLowerCase() }
}, f = "_";
function b(e, o) {
  const n = [];
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    if (Object.keys(o).includes(r)) {
      n.push(o[r]);
      continue;
    }
    if (r === "\\") {
      n.push(e[t + 1]), t++;
      continue;
    }
    if (r === "{") {
      let c = "";
      for (let s = t + 1; s < e.length; s++)
        if (e[s] === "}") {
          n.push({ pattern: c }), t += c.length + 1;
          break;
        } else
          c += e[s];
      continue;
    }
    n.push(r);
  }
  return n;
}
function x(e, o) {
  let n = "", t = 0;
  for (let r = 0; r < o.length; r++) {
    let c = !1;
    const s = o[r];
    if (s) {
      if (typeof s == "string") {
        n += s;
        continue;
      }
      for (let l = t; l < e.length; l++) {
        let a = e[l];
        t++;
        const i = new RegExp(s.pattern);
        if (s.transform && (a = s.transform(a)), i.test(a)) {
          n += a, c = !0;
          break;
        }
      }
      c || (n += f);
    }
  }
  return n;
}
function L(e, o) {
  let n = "";
  for (let t = 0; t < o.length; t++) {
    const r = e[t];
    typeof o[t] == "object" && r !== f && (n += r);
  }
  return n;
}
function C(e, o, n) {
  const t = n[o];
  return typeof t == "object" ? new RegExp(t.pattern).test(
    t.transform ? t.transform(e) : e
  ) : !1;
}
const P = {
  mounted: (e, o) => {
    let n = !1;
    const t = e instanceof HTMLInputElement ? e : e.querySelector("input");
    if (t === null || !o.value.mask)
      return;
    const r = {
      maskPattern: b(o.value.mask, {
        ...y,
        ...o.value.tokens || {}
      }),
      raw: o.value.raw
    };
    let c = "";
    g(() => {
      s(x(t.value, r.maskPattern));
    });
    function s(a) {
      c = a, t.value = a, t.dispatchEvent(new Event("input")), r.raw && r.raw(L(a, r.maskPattern));
    }
    function l(a, i, p) {
      const u = t.value.indexOf(f);
      g(() => {
        a.target.setSelectionRange(
          u === -1 ? i : u,
          i === p ? u : p
        );
      });
    }
    t.addEventListener("focus", (a) => {
      l(a, 0, 0);
    }), t.addEventListener("blur", () => {
      n = !1;
    }), t.addEventListener("click", (a) => {
      n || (l(a, 0, 0), n = !0);
    }), e.addEventListener("input", (a) => {
      const { selectionStart: i, selectionEnd: p, value: u } = a.target, k = a.data;
      function m() {
        if (C(
          k,
          i - 1,
          r.maskPattern
        )) {
          const d = r.maskPattern[i - 1], v = d.transform ? d.transform(k) : k, w = u.substring(0, i - 1) + v + u.substring(i + 1);
          s(w);
        } else
          s(c);
        l(a, i, p);
      }
      switch (a.inputType) {
        case "":
        case "insertText":
          m();
          break;
        case "deleteContentBackward":
          typeof r.maskPattern[i] == "string" ? s(c) : s(
            h(c, i, f)
          ), g(() => {
            a.target.setSelectionRange(
              i,
              i
            );
          });
          break;
        case "deleteContentForward":
          typeof r.maskPattern[i] == "string" ? s(c) : s(
            h(c, i, f)
          ), g(() => {
            a.target.setSelectionRange(
              i + 1,
              i + 1
            );
          });
          break;
      }
    });
  }
}, S = { vMask: P };
export {
  S as default,
  P as vMask
};
